import { CriterionFilters } from "@bundles/parts/data/model"

export const sortCriteriaFilterByName = (filters?: CriterionFilters[]): CriterionFilters[] => {
    return (
        filters?.sort((a, b) => {
            if (a.name > b.name) {
                return 0
            }
            if (a.name < b.name) {
                return 1
            }
            return -1
        }) || []
    )
}
